// OK
// import axios from "axios";
import Properties from "../properties"
import apiClient from "../plugins/axios-instance";

const API_URL = "https://pelanggan." +Properties.DOMAIN_URL +"/api/v1";

export default class KategoriPromoAPIService {
  constructor() {}
  static getAll = (limit, page) => {
    return apiClient.get(
      API_URL + "/kategori-promos/limit/" + limit + "?page=" + page,
      {
      }
    );
  }
  static getKode = (limit, page, kode) =>
    apiClient.get(
      API_URL + "/kategori-promos/limit/" + limit + "?page=" + page,
      {
        params: {kode: kode}
      }
    );

  static getAllUmum = (limit, page) =>
    apiClient.get(
      API_URL + "/kategori-promos/limit/" + limit + "?page=" + page,
      {
        params: { khusus: 0, status: "A" },
      }
    );

  static getAllKhusus = (limit, page) =>
    apiClient.get(
      API_URL + "/kategori-promos/limit/" + limit + "?page=" + page,
      {
        params: { khusus: 1, status: "A" },
      }
    );

  static edit = (kode, promo) =>
    apiClient.put(API_URL + "/kategori-promos/" + kode, promo, {
    });
  static create = (notif) =>
    apiClient.post(API_URL + "/kategori-promos", notif, {
    });
  static delete = (kode, nik) =>
    apiClient.delete(API_URL + "/kategori-promos/" + kode, {
      params: {
        user_update: nik,
      },
    });
}
